{
	"login": {
		"title": "Вход в StudyHub",
		"lead": "Один аккаунт для всех сервисов экосистемы.",
		"signIn": "Войти",
		"legalDisclaimer": "Нажимая «Войти», ты соглашаешься с Условиями использования и Политикой конфиденциальности.",
		"devOr": "или",
		"emailLabel": "Email",
		"passwordLabel": "Пароль",
		"emailSubmit": "Войти",
		"emailSignedIn": "С возвращением!",
		"devHint": "Dev-режим: email и пароль",
		"devQuickPick": "Быстрый выбор",
		"forgotPassword": "Забыли пароль?",
		"togglePassword": "Показать или скрыть пароль",
		"demoLoadingTitle": "Переходим на Exchange…",
		"demoLoadingDesc": "Секунду, открываем безопасную страницу входа.",
		"errorTitle": "Не удалось войти",
		"errorBody": "Exchange вернул ошибку: {code}",
		"errorRetry": "Попробовать снова",
		"errorHelp": "Связаться с поддержкой",
		"offlineBanner": "Нет сети — войти невозможно. Проверь подключение.",
		"alreadyAuthRedirect": "Перенаправляем в StudyHub…",
		"selectDevAccount": "Выбран {email}",
		"previewBadge": "Превью платформы",
		"heroTitle": "Загрузил лекцию — получил конспект, карточки и тест за минуту.",
		"heroLead": "StudyHub превращает PDF, видео, фото и записи лекций в готовый учебный пакет: конспект, карточки, тест и AI-репетитора, который знает твой материал.",
		"mockMaterialTitle": "Лекция 12 — Клеточное дыхание",
		"mockMaterialMeta": "91 минута · готово 47 сек назад",
		"mockBadgeNotes": "Конспект · 3 уровня",
		"mockBadgeCards": "24 карточки",
		"mockBadgeQuiz": "Тест · 15 вопросов",
		"mockBadgePodcast": "Аудио-резюме · 8:42",
		"kpiSpeed": "~45 сек",
		"kpiSpeedDesc": "от загрузки до готового материала",
		"kpiFree": "50 / нед.",
		"kpiFreeDesc": "AI-генераций на Free",
		"kpiLang": "AI",
		"kpiLangDesc": "конспекты, карточки, тесты",
		"helpLink": "Помощь",
		"emailToggleLabel": "Войти по email и паролю",
		"themeToggle": "Сменить тему",
		"mockMaterialReady": "Готово",
		"footerCopyright": "© 2026 StudyHub",
		"footerPrivacy": "Политика конфиденциальности",
		"footerTerms": "Пользовательское соглашение",
		"kpiOffline": "Офлайн",
		"kpiOfflineDesc": "ваши материалы без подключения к сети"
	},
	"callback": {
		"finishing": "Завершаем вход…"
	},
	"sessionExpired": {
		"title": "Сессия истекла",
		"body": "Чтобы продолжить, войдите в свою учетную запись еще раз.",
		"cta": "Войти заново",
		"localChangesSafe": "Ваши офлайн-изменения сохранены на этом устройстве и будут синхронизированы после входа в систему."
	},
	"signup": {
		"title": "Создать аккаунт",
		"submit": "Создать аккаунт",
		"haveAccount": "Уже есть аккаунт?",
		"loginLink": "Войти"
	},
	"logout": {
		"action": "Выйти",
		"confirmTitle": "Выйти из аккаунта?",
		"confirmDescription": "Локальные несинхронизированные данные могут быть потеряны.",
		"confirmAction": "Выйти"
	},
	"consent": {
		"title": "Согласие на использование",
		"privacy": "Я принимаю Политику конфиденциальности",
		"terms": "Я принимаю Условия использования",
		"aiDisclaimer": "Понимаю, что StudyHub использует AI для генерации конспектов, карточек и тестов. AI может ошибаться — важную информацию стоит проверить в источнике.",
		"submit": "Принять и продолжить",
		"required": "Для продолжения нужно принять все пункты"
	},
	"accountDeletion": {
		"title": "Удалить аккаунт",
		"description": "Аккаунт будет помечен на удаление. Через 30 дней все данные будут безвозвратно стёрты. До этого момента удаление можно отменить и вернуться.",
		"confirm": "Удалить аккаунт",
		"cancel": "Отменить удаление",
		"gracePeriodNotice": "Удаление запланировано на {date}"
	},
	"errors": {
		"invalidCredentials": "Неверный email или пароль",
		"accountBanned": "Аккаунт заблокирован",
		"sessionExpired": "Сессия истекла — войди заново"
	},
	"impersonation": {
		"processing": "Входим под пользователем…",
		"errorTitle": "Не удалось войти под пользователем",
		"errorHelp": "Сессия могла истечь или ссылка уже использована. Вернись в админку и попробуй снова.",
		"backToAdmin": "Вернуться в админку",
		"banner": "Вы вошли как {email} (режим администратора).",
		"bannerNoEmail": "Вы вошли под другим пользователем (режим администратора).",
		"exit": "Завершить"
	},
	"sessionRevoked": {
		"body": "Сессия была завершена. Войдите заново.",
		"passwordChanged": "Пароль изменён — войдите заново."
	}
}
